import { FC, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSnapshot } from 'valtio';
import { loadStatistics } from '../../issues/active-issues/api/active-issues-api';
import IssuesStore from '../../issues/active-issues/stores/issues-store';
import {
  useGradualUpdate,
  useIsScanning,
} from '../../new-scan/actions/scan-actions';
import {
  loadIssuesScore,
  saveLastDrawerHeight,
} from '../actions/single-application-actions';
import ApplicationDrawer from '../components/ApplicationDrawer/ApplicationDrawer';
import ApplicationsStore from '../stores/applications-store';
import { selectApplication } from '../stores/applications-store-actions';

const ApplicationDrawerContainer: FC<
  React.PropsWithChildren<ApplicationDrawerContainerProp>
> = ({ className }) => {
  const {
    selectedApp,
    loadingSingleApp,
    lastDrawerHeight,
    applicationIssuesScore,
  } = useSnapshot(ApplicationsStore);
  const { applicationStatistics } = useSnapshot(IssuesStore);
  const [searchParams] = useSearchParams();
  const appId = searchParams.get('appId');
  const isScanning = useIsScanning();

  useEffect(() => {
    appId && selectApplication(appId);
  }, [appId]);

  useEffect(() => {
    if (selectedApp) {
      loadIssuesScore();
      loadStatistics(selectedApp.appName);
    }
  }, [isScanning, selectedApp, selectedApp?.appName]);

  useGradualUpdate(
    useCallback(() => {
      if (selectedApp) {
        loadIssuesScore();
      }
    }, [selectedApp]),
  );

  if (!selectedApp && !loadingSingleApp) {
    return null;
  }

  return (
    <ApplicationDrawer
      className={className}
      app={selectedApp}
      loading={loadingSingleApp}
      defaultHeight={lastDrawerHeight}
      onResizeStop={saveLastDrawerHeight}
      applicationIssuesScore={applicationIssuesScore}
      applicationStatisticas={applicationStatistics}
    />
  );
};

interface ApplicationDrawerContainerProp {
  className: string;
}

export default ApplicationDrawerContainer;
